import { API_BASE } from '../config/api';
import { tokenStore } from './tokenStore';
import { LoginCredentials, AuthUser } from '../types/auth';

/** Auth qua AgentX /auth (thay Cognito/Amplify). */
export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthUser> {
    const res = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: credentials.email, password: credentials.password }),
    });
    const body = await res.json().catch(() => null);
    if (!res.ok || !body?.access_token) {
      throw new Error(body?.error || 'Sign in failed');
    }
    const groups: string[] = body.user?.roles ?? [];
    const email: string = body.user?.email ?? credentials.email;
    tokenStore.set(body.access_token, body.refresh_token ?? null, { email, groups });
    return { email, groups, token: body.access_token };
  },

  async logout(): Promise<void> {
    const refresh = tokenStore.refresh;
    tokenStore.clear();
    if (refresh) {
      try {
        await fetch(`${API_BASE}/auth/logout`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refresh }),
        });
      } catch {
        // best-effort
      }
    }
  },

  async getCurrentUser(): Promise<AuthUser | null> {
    const token = tokenStore.access;
    const user = tokenStore.user;
    if (!token || !user) return null;
    return { email: user.email, groups: user.groups, token };
  },

  // Helper đồng bộ cho guard client-side (thay groups từ cognito:groups).
  getGroups(): string[] {
    return tokenStore.user?.groups ?? [];
  },
  getEmail(): string | null {
    return tokenStore.user?.email ?? null;
  },
  isAuthenticated(): boolean {
    return !!tokenStore.access && !!tokenStore.user;
  },
};
